import React from 'react';
import { useTranslation } from 'react-i18next';
import WixelLogoAndText from '@wix/da-ds/pkg/WixelLogoAndText';
import { BiData, type DefaultBiEvent } from '@wix/da-bi/pkg/events';
import CreatedWithBanner from '../CreatedWithBanner';

import s from './CreatedWithWixelBanner.scss';

interface Props {}

const CreatedWithWixelBanner: React.FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <CreatedWithBanner
      logo={<WixelLogoAndText className={s['logo']} />}
      titleText={t('deviation.details.createdWith.wixel.title')}
      ctaText={t('deviation.details.createdWith.wixel.link.text')}
      linkHref={t('deviation.details.createdWith.wixel.link.href')}
      linkBiData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'wixel-devpage-banner',
      })}
      createdWithPrefix
    />
  );
};
CreatedWithWixelBanner.displayName = 'CreatedWithWixelBanner';

export default CreatedWithWixelBanner;
